import { CloseOutlined } from "@mui/icons-material";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import React, { useState } from "react";
import { apiGatewayAxiosInstance } from "../../utils/axios";
import AlertMessageComponent from "../components/AlertMessageComponent";
import { ERoles } from "../../config";
import useAuth from "../../hooks/useAuth";

function DeductModal({ open, handleClose, currentData, getMasterBillingDetails, setOperationStatus }) {
    const [deduct, setDeduct] = useState(0);
    const [description, setDescription] = useState("");
    const [errorResponse, setErrorResponse] = useState("");
    const [loading, setLoading] = useState(false);
    const { user } = useAuth();
    const [error, setError] = useState(false);

    const handleChange = event => {
        const rawValue = event.target.value;

        if (rawValue === "") {
            setDeduct(null);
            setError(false);
            return;
        }

        const value = Number(rawValue);

        if (isNaN(value) || value < 0) {
            setError(true);
            return;
        }

        if (value > 1000000) {
            return;
        }

        setError(false);
        setDeduct(value);
    };

    const updateCurrentBalance = async (deduct, description) => {
        try {
            setLoading(true);
            const updatedBillingData = { ...currentData };
            updatedBillingData.deduct = Number(deduct);
            updatedBillingData.description = description;

            const payload = { ...updatedBillingData, resellerName: updatedBillingData.data.resellerName, orgName: updatedBillingData.data.orgName };
            if (user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN) {
                payload.roleName = ERoles.RESELLER_ADMIN;
            }
            if (user?.roleName.toLowerCase() === ERoles.RESELLER_ADMIN) {
                payload.roleName = ERoles.ORG_ADMIN;
            }
            delete payload.data;

            //handle when deduction amount is more than current balance
            if (updatedBillingData.currentBalance < updatedBillingData.deduct) {
                setErrorResponse("Deduction amount cannot be greater than current balance!");
            }
            const response = await apiGatewayAxiosInstance.post("/billing_management/current-billing/update-master-billing-details", payload);
            setOperationStatus({
                message: "Deduction Successful.",
                success: true,
                failed: false,
            });
            getMasterBillingDetails();
            handleClose();
            setLoading(false);
            return response;
        } catch (error) {
            console.error("Error updating balance:", error);
            setLoading(false);
            let errorMessage = "Failed to get template details.";
            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setErrorResponse(errorMessage);
        }
    };

    return (
        <Dialog open={open} aria-labelledby="filter-dialog-title" maxWidth={"xs"} fullWidth>
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h5">Deduct Balance {currentData?.data?.resellerName}</Typography>

                <IconButton onClick={handleClose}>
                    <CloseOutlined />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid>
                    <TextField
                        type="number"
                        name="deduct"
                        style={{ width: "100%" }}
                        className="field-spacing"
                        label="Deduct Balance (INR)"
                        variant="outlined"
                        value={deduct ?? ""}
                        onChange={handleChange}
                        // onBlur={handleBlur}
                        error={error}
                        inputProps={{
                            min: 0,
                            max: 1000000,
                        }}
                    />
                    <Box mt={1}>
                        <Typography variant="caption" color="text.secondary">
                            Maximum allowed recharge is ₹10 Lakh
                        </Typography>
                    </Box>
                </Grid>

                <Grid>
                    <TextField
                        type="text"
                        name="description"
                        style={{ width: "100%" }}
                        className="field-spacing"
                        label="Description"
                        variant="outlined"
                        multiline
                        rows={3}
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                        inputProps={{
                            maxLength: 500,
                        }}
                    />
                    <React.Fragment>
                        <Box
                            sx={{
                                p: 1,
                                mx: 1,
                                fontSize: "0.875rem",
                                fontWeight: "700",
                                display: "flex",
                                flexDirection: "row-reverse",
                            }}
                        >
                            {`${description.length}`}
                            /500
                        </Box>
                    </React.Fragment>
                </Grid>

                <Grid container flexDirection={"row-reverse"} gap={2} paddingTop={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => updateCurrentBalance(deduct, description)}
                        disabled={error || !deduct || loading || Number(deduct) === 0}
                        startIcon={loading ? <CircularProgress size={24} color="inherit" /> : null}
                    >
                        {loading ? "Submitting..." : "Submit"}
                    </Button>
                    <Button variant="outlined" color="error" onClick={handleClose}>
                        Cancel
                    </Button>
                </Grid>
            </DialogContent>

            <AlertMessageComponent
                message={errorResponse}
                // fieldName={"getAllTemplatesByPageSizeErrorMessage"}
                handleClose={() => setErrorResponse("")}
                show={Boolean(errorResponse)}
            />
        </Dialog>
    );
}

export default DeductModal;
